"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsValidDurationRecord = IsValidDurationRecord;
var ecma402_abstract_1 = require("@formatjs/ecma402-abstract");
var constants_1 = require("../constants");
var DurationRecordSign_1 = require("./DurationRecordSign");
function IsValidDurationRecord(record) {
    var sign = (0, DurationRecordSign_1.DurationRecordSign)(record);
    for (var _i = 0, TABLE_1_1 = constants_1.TABLE_1; _i < TABLE_1_1.length; _i++) {
        var key = TABLE_1_1[_i];
        var v = record[key];
        (0, ecma402_abstract_1.invariant)(isFinite(Number(v)), "".concat(key, " is not finite"));
        if (v < 0 && sign > 0) {
            return false;
        }
        if (v > 0 && sign < 0) {
            return false;
        }
    }
    return true;
}
